import { createTheme } from "@mui/material";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#fcce38"
    }
  }
})

export default defaultTheme